import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

/*
 * Workaround for setting CSS custom properties:
 * https://github.com/angular/angular/issues/9343
 *
 * Can work for any style properties.
 */
@Directive({
    selector: '[appMediegoCSSProps]',
    standalone: false
})
export class CSSPropsDirective implements OnChanges {

  @Input('appMediegoCSSProps') cssProps: { [p: string]: string };

  constructor(private element: ElementRef) { }

  ngOnChanges({ cssProps }: SimpleChanges) {
    if (cssProps && cssProps.currentValue) {
      const { style } = this.element.nativeElement;
      for (const [k, v] of Object.entries(cssProps.currentValue)) {
        style.setProperty(k, v);
      }
    }
  }

}
